export default {
  LeftMenu: {
    Control: 'Control',
    EmployeeList: 'Nhân viên',
    CollapseText: 'Thu gọn',
    InventoryItem: 'Kho',
    Account: 'Tài khoản',
    Dashboard: 'Tổng quan',
    Treasury: 'Kho bạc',
    Etreasury: 'Kho bạc điện tử',
    CA: 'Tiền mặt',
    BA: 'Tiền gửi',
    SU: 'Công cụ dụng cụ',
    FA: 'Tài sản cố định',
    Salary: 'Tiền lương',
    PU: 'Mua hàng',
    SA: 'Bán hàng',
    Invoice: 'Hóa đơn',
    Tax: 'Thuế',
    GL: 'Tổng hợp',
    Report: 'Báo cáo',
    Examine: 'Kiểm tra dự toán',
    EstimateSummary: 'Tổng hợp dự toán',
    Symmetrical: 'Lập và cân đối',
    SectorWideEstimate: 'Lập dự toán toàn ngành',
    ThreeYearFiveYearEstimate: 'Dự toán 3 năm',
    EstimateLoanAndPay: 'Dự toán vay trả nợ',
    Allocation: 'Phân bổ, giao dự toán',
    LoanRepayment: 'Dự toán Vay - Trả nợ',
    TrackProgress: 'Theo dõi thực hiện',
    Form: 'Biểu mẫu',
    BeforeData: 'Dữ liệu năm trước',
    InstructEstimate: 'Hướng dẫn lập dự toán',
    ReceiveInstruction: 'Nhận hướng dẫn',
    Enact: 'Ban hành',
    ManageTemplate: 'Quản lý biểu mẫu',
    Dictionary: 'Danh mục',
    Estimate: 'Lập dự toán',
    BeginYearEstimate: 'Dự toán nhu cầu',
    EstimateInitial: 'Dự toán đầu năm',
    AdjustEstimate: 'Dự toán điều chỉnh',
    AdditionalEstimates: 'Dự toán bổ sung',
    ReceiveDecision: 'Nhận quyết định giao',
    EnterReceiveDecision: 'Nhập quyết định giao',
    RepeatEstimate: 'Lập lại dự toán',
    Other: 'Khác',
    IndustryEstimate: 'Lập dự toán toàn ngành',
    CreateAllocation: 'Lập phương án phân bổ',
    DeliverEstimate: 'Giao dự toán',
    TrackingDeliver: 'Theo dõi giao',
    TrackingChart: 'Biểu đồ theo dõi',
    ImplementationData: 'Dữ liệu thực hiện',
  },
  Nav: {
    PostedDate: 'Ngày hạch toán:',
    Search: 'Tìm chứng từ',
  },
};
